import {Column, Entity, PrimaryColumn, ManyToMany, JoinTable, OneToMany} from "typeorm"
import { SimpleClient } from "../../interfaces"
import { Client } from "./Client"
import { Order } from "./Order"
import { CustomAddress } from "./CustomAddress"

@Entity()
export class User {

	@PrimaryColumn() 
	email!: string

	@Column()
	password?: string

	@Column()
	salt?: string

	@Column()
	customerName!: string

	@Column()
	role!: string

	@Column({length: 10000})
	config!: string

	@Column("mediumtext")
	stat_layout!: string

	@Column("mediumtext")
	stat_components!: string

	@Column("int")
	user_level!: number

	@Column()
	firstName!: string

	@ManyToMany(() => Client, (client) => client.users)
	@JoinTable()
	clients?: Client[]

	@OneToMany(() => Order, (order) => order.client)
	orders?: Order[]

	@OneToMany(() => Order, (order) => order.deliveryProvider)
	deliverySources?: Order[]

	@OneToMany(() => CustomAddress, (address) => address.user)
	customDeliveryAddresses?: CustomAddress[]

	simpleClients?: SimpleClient[]
}